module.exports = __webpack_public_path__ + "static/media/sagar_satbhai.df20c063.png";